var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{class:_vm.textCenter ? 'justify-center' : ''},[_vm._v("Volunteer Experience")]),_c('ListCard',{attrs:{"items":_vm.experience}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }